import { useState, useEffect } from 'react';
import { referenceAPI, batchesAPI, coursesAPI } from '../../../services/api';
import { normalizeApiListResponse } from '../../../utils/apiListNormalize';

/** Courses + reference entities for admin forms (ISP: split from masters). */
export function useAdminFormCatalog(token) {
  const [courses, setCourses] = useState([]);
  const [coursesLoading, setCoursesLoading] = useState(false);
  const [courseCategories, setCourseCategories] = useState([]);
  const [domains, setDomains] = useState([]);
  const [batches, setBatches] = useState([]);
  const [counselors, setCounselors] = useState([]);

  useEffect(() => {
    if (!token) return;

    setCoursesLoading(true);
    coursesAPI
      .getAll()
      .then((res) => {
        const coursesArray = normalizeApiListResponse(res.data);
        console.log('📚 Courses fetched in useAdminFormCatalog:', coursesArray.length, coursesArray);
        setCourses(coursesArray);
      })
      .catch((err) => {
        console.error('Failed to fetch courses:', err.response?.data || err.message);
        setCourses([]);
      })
      .finally(() => setCoursesLoading(false));

    const fetchReferenceData = async () => {
      try {
        const [courseCategoriesRes, domainsRes, batchesRes, counselorsRes] = await Promise.all([
          referenceAPI.getCourseCategories(),
          referenceAPI.getDomains(),
          batchesAPI.getAll(),
          referenceAPI.getCounselors()
        ]);

        setCourseCategories(normalizeApiListResponse(courseCategoriesRes.data));
        setDomains(normalizeApiListResponse(domainsRes.data));
        setBatches(normalizeApiListResponse(batchesRes.data));
        setCounselors(normalizeApiListResponse(counselorsRes.data));
      } catch (error) {
        console.error('Error fetching reference data:', error);
      }
    };
    fetchReferenceData();
  }, [token]);

  return {
    courses,
    coursesLoading,
    courseCategories,
    domains,
    batches,
    counselors,
    refreshBatches: async () => {
      const batchesRes = await batchesAPI.getAll();
      const list = normalizeApiListResponse(batchesRes.data);
      setBatches(list);
      return list;
    },
  };
}
